var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mobile-navigator-routes",on:{"click":_vm.openRoutesList}},[_c('app-icon',{attrs:{"icon":"is-in-route","is-active":_vm.isRoutesListOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }